const savesInFlight = new Set<string>();

export const markPullSaveStarted = (pullAttemptKey: string): void => {
	savesInFlight.add(pullAttemptKey);
};

export const markPullSaveSettled = (pullAttemptKey: string): void => {
	savesInFlight.delete(pullAttemptKey);
};

const pullSavesInFlight = (): string[] => [...savesInFlight];

export default pullSavesInFlight;
